import { useEffect, useState } from "react";
import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { Link } from "react-router";
import BaseCard from "../../components/card/BaseCard";
import FormItemInput from "../../components/form-item/form-item-input";
import { Icon } from "@iconify/react";
import TicketUserItem from "../../components/TicketUserItem";
import { Avatar, Button, Collapse, Empty } from "antd";
import MessageBox from "../../components/MessageBox";
import AttachmentsItem from "../../components/AttachmentsItem";
import MessageBar from "../../components/MessageBar";
import { $api, type components } from "../../helper";
import { tokenMock } from "../../helper/mock";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { useNotify } from "../../helper/notify";

export default function Ticket() {
  const [height, setHeight] = useState("");
  const [ticketId, setTicketId] = useState("");
  const [color, setColor] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const [search, setSearch] = useState("");
  const [ticketDetail, setTicketDetail] =
    useState<components["schemas"]["SiteTicketDetailItem"]>();
  const { data, refetch } = $api.useQuery("get", "/site-api/v1/ticket/", {
    headers: {
      Authorization: tokenMock,
      lang: "fa",
    },
  });

  const detail = $api.useMutation("get", "/site-api/v1/ticket-detail/");
  const closeTicket = $api.useMutation("put", "/site-api/v1/ticket/");

  useEffect(() => {
    if (!ticketId) return;
    detail.mutate(
      {
        params: {
          query: {
            ticket_u_id: ticketId,
          },
        },
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      },
      {
        onSuccess: (data) => {
          setTicketDetail(data.data);
          refetch();
        },
      },
    );
  }, [ticketId]);

  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("تیکت ها");
  }, []);

  useEffect(() => {
    const el = document.querySelector("#message-bar");
    if (!el) return;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setHeight((entry.contentRect.height + 50).toString());
      }
    });

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const avatarColors = [
    "bg-info-500!",
    "bg-success-500!",
    "bg-warning-500!",
    "bg-error-500!",
  ];

  return (
    <div className="flex flex-col gap-6">
      <ConfirmModal
        success={
          Number(ticketDetail?.ticket_detail?.ticket_status) !== 3
            ? false
            : true
        }
        open={isOpen}
        onClose={() => setIsOpen(false)}
        title={
          Number(ticketDetail?.ticket_detail?.ticket_status) !== 3
            ? "بستن تیکت"
            : "باز کردن تیکت"
        }
        description={
          Number(ticketDetail?.ticket_detail?.ticket_status) !== 3
            ? "ایا از بستن تیکت مطمئن هستید ؟"
            : "ایا از باز کردن تیکت مطمئن هستید ؟"
        }
        pending={closeTicket.isPending}
        action={() => {
          closeTicket.mutate(
            {
              params: {
                query: {
                  ticket_u_id: ticketId,
                },
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                notify.success(data.message);
                setIsOpen(false);
                setTicketDetail(data.data);
              },
            },
          );
        }}
      />
      <div className="w-full flex justify-end items-center">
        <Link to={"/add-ticket"} className="button-style">
          ایجاد تیکت
        </Link>
      </div>
      <BaseCard props={{ className: "p-0! flex overflow-hidden h-[75svh]" }}>
        {/* right col */}
        <div className="w-96 flex flex-col h-auto border-l border-grayscale-200">
          <div className="w-full flex items-center gap-3 pt-6 px-6"></div>
          <div className="p-6">
            <FormItemInput
              inputProps={{
                prefix: (
                  <Icon
                    icon={"solar:magnifer-linear"}
                    className="text-lg text-grayscale-500"
                  />
                ),
                placeholder: "جستحو کاربر",
                onChange: (e) => {
                  setSearch(e.target.value);
                },
              }}
            />
          </div>
          <div className="flex flex-col overflow-auto">
            {data?.data
              ?.filter(
                (e) => e.user_name.includes(search) || e.title.includes(search),
              )
              ?.map((e, i) => (
                <button
                  disabled={detail.isPending}
                  onClick={() => {
                    setTicketId(e.u_id);
                    setColor(
                      avatarColors[e.u_id.charCodeAt(0) % avatarColors.length],
                    );
                  }}
                  className="cursor-pointer disabled:cursor-not-allowed"
                  key={i + "ticket-user-item"}
                >
                  <TicketUserItem ticketId={ticketId} data={e} />
                </button>
              ))}
          </div>
        </div>
        <div className="flex-1 flex flex-col">
          {/* header */}
          <div className="border-b border-grayscale-200 flex justify-between w-full py-4 px-6">
            <div className="flex gap-2">
              <Avatar size="large" className={`w-12! h-12! ${color}`}>
                {ticketDetail?.user_detail.user_name?.at(0)}
              </Avatar>
              <div className="flex flex-col gap-0.5">
                <span className="text-16-regular">
                  {ticketDetail?.ticket_detail.ticket_title}
                </span>
                <span className="text-14-regular text-grayscale-500">
                  {detail.data?.data.ticket_detail?.ticket_category}
                </span>
              </div>
            </div>
            {ticketDetail ? (
              Number(ticketDetail?.ticket_detail?.ticket_status) !== 3 ? (
                <div className="">
                  <Button
                    onClick={() => setIsOpen(true)}
                    danger
                    icon={
                      <Icon
                        icon={"solar:close-circle-outline"}
                        className="text-2xl mt-1"
                      />
                    }
                  >
                    بستن تیکت
                  </Button>
                </div>
              ) : (
                <div className="">
                  <Button
                    onClick={() => setIsOpen(true)}
                    className="text-success-600! border-success-600!"
                    icon={
                      <Icon
                        icon={"ic:twotone-open-in-full"}
                        className="text-2xl mt-1 text-success-600!"
                      />
                    }
                  >
                    باز کردن تیکت
                  </Button>
                </div>
              )
            ) : (
              ""
            )}
          </div>
          <div className="flex-1 flex min-h-0">
            {/* content */}
            <div className="flex-1 flex relative">
              <div
                style={{ paddingBottom: `${height}px` }}
                className="px-6 pt-6 gap-6 flex-col overflow-auto min-h-0 flex flex-1"
              >
                {ticketDetail ? (
                  detail.data?.data.messages.map((e, i) => (
                    <MessageBox
                      key={i + "message-user"}
                      data={e}
                      type={e.is_admin ? 1 : 2}
                    />
                  ))
                ) : (
                  <div className="w-full h-full flex-center">
                    <Empty description="پیامی وجود ندارد" />
                  </div>
                )}
              </div>
              {ticketDetail &&
              Number(ticketDetail?.ticket_detail.ticket_status) !== 3 ? (
                <MessageBar
                  setTicketDetail={setTicketDetail}
                  refetch={detail}
                  ticketId={ticketId}
                  disabled={ticketId ? false : true}
                />
              ) : (
                ""
              )}
            </div>
            <div className="w-96 flex flex-col items-center border-r border-grayscale-200 overflow-auto">
              <div className="p-6 flex flex-col gap-4 items-center">
                <Avatar className={`w-24! h-24! text-3xl! ${color}`}>
                  {ticketDetail?.user_detail?.user_name.at(0)}
                </Avatar>
                <div className="flex flex-col items-center gap-0">
                  <span className="text-20-regular">
                    {ticketDetail?.user_detail?.user_name}
                  </span>
                  <span className="text-16-regular text-grayscale-600">
                    {detail.data?.data?.ticket_detail?.ticket_category}
                  </span>
                </div>
              </div>
              <div className="flex flex-col w-full">
                <Collapse
                  bordered={false}
                  style={{ direction: "rtl" }}
                  className="bg-transparent!"
                  classNames={{
                    header: "bg-grayscale-50! px-4! py-3! rounded-none!",
                  }}
                  expandIconPlacement="end"
                  expandIcon={({ isActive }) => (
                    <Icon
                      icon={"solar:alt-arrow-left-line-duotone"}
                      className={`duration-200! text-grayscale-800! transition-all! text-xl! ${
                        isActive ? "-rotate-90" : "rotate-0"
                      }`}
                    />
                  )}
                  items={[
                    {
                      label: (
                        <span className="text-grayscale-800">
                          اطلاعات کاربر
                        </span>
                      ),
                      children: (
                        <div className="flex text-grayscale-500! flex-col gap-5 mt-4">
                          <div className="flex gap-2 items-start">
                            <Icon
                              className="text-2xl"
                              icon={"solar:map-point-bold"}
                            />
                            <span className="flex-1 text-grayscale-950">
                              {ticketDetail?.user_detail?.user_address}
                            </span>
                          </div>
                          <div className="flex text-right gap-2 items-start">
                            <Icon
                              className="text-2xl"
                              icon={"solar:phone-bold"}
                            />
                            <a
                              dir="ltr"
                              className="flex-1 text-grayscale-950!"
                              target="_blank"
                              href={`tel:${ticketDetail?.user_detail.user_phone_number}`}
                            >
                              {ticketDetail?.user_detail.user_phone_number}
                            </a>
                          </div>
                          <div className="flex gap-2 items-start">
                            <Icon
                              className="text-2xl"
                              icon={"solar:letter-bold"}
                            />
                            <a
                              target="_blank"
                              href={`mailto:${ticketDetail?.user_detail.user_email}`}
                              className="flex-1 text-grayscale-950!"
                            >
                              {ticketDetail?.user_detail.user_email}
                            </a>
                          </div>
                        </div>
                      ),
                    },
                    {
                      label: (
                        <span className="text-grayscale-800">
                          فایل های ارسال شده
                        </span>
                      ),
                      children: (
                        <div className="flex flex-col gap-6 mt-4">
                          {ticketDetail?.file_detail.map((e, i) => (
                            <AttachmentsItem
                              key={i + "attachments-item"}
                              data={e}
                            />
                          ))}
                        </div>
                      ),
                    },
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </BaseCard>
    </div>
  );
}
